import axios from "axios";
import endPoints from "../../../../config/endPoints";



export const findReceiptApi = async (receiptNumber) => {
  return axios.get(`${endPoints.receipts}/tracking/${receiptNumber}`);
};

export const getOtpCodeApi = async (query) => {
  return axios.post(`${endPoints.receipts}/find/get-otp`, query);
};

export const validateOtpApi = async (query) => {
  return axios.post(`${endPoints.receipts}/find/validate-otp`, query);
};

export const generateRcptReportApi = async (receiptNumber) => {
  return axios.post(`${endPoints.reports}`, { receiptNumber });
};

// export const findReceiptApi = async (reqBody) => {
//   return axios.get(`${endPoints.receipts}/tracking/receiptNumber.str`, reqBody);
// };

// export const getOtpCodeApi = async (reqBody) => {
//   return axios.post(`${endPoints.receipts}/find/get-otp`, reqBody);
// };

// export const validateOtpApi = async (reqBody) => {
//   return axios.post(`${endPoints.receipts}/find/validate-otp`, reqBody);
// };

// export const generateRcptReportApi = async (reqBody) => {
//   return axios.post(`${endPoints.reports}`, reqBody);
// };